module.exports = __webpack_public_path__ + "ai-bot-body-think2wp2f937fe2b9da4d7f88733545cfea0f80.png";